import { call, fork, put, takeEvery } from 'redux-saga/effects';

import {
  FETCH_DASHBOARD_BINS,
  fetchDashboardBinsSuccess,
  fetchDashboardBinsFail,
  FETCH_TOTAL_PENDING_ALERTS,
  fetchTotalPendingAlertsSuccess,
  fetchTotalPendingAlertsFail,
  FETCH_CASE_AGING_STATS,
  fetchCaseAgingStatsSuccess,
  fetchCaseAgingStatsFail
} from '../../redux/actions/cm/dashboard';

import {
  fetchDashboardBins,
  fetchTotalPendingAlerts,
  fetchCaseAgingStats
} from '../../services/cm/dashboard';

function* fetchDashboardBinsWorker() {
  try {
    const {
      dashboardBins,
      httpConfig,
      invalidExtensions,
      validExtensions,
      maxAutomationLimit,
      framlViewEnabled
    } = yield call(fetchDashboardBins);

    yield put(
      fetchDashboardBinsSuccess({
        dashboardBins,
        httpConfig,
        invalidExtensions,
        validExtensions,
        maxAutomationLimit,
        framlViewEnabled
      })
    );
  } catch (error) {
    yield put(fetchDashboardBinsFail());
  }
}

export function* watchFetchDashboardBins() {
  yield takeEvery(FETCH_DASHBOARD_BINS, function* () {
    yield fork(fetchDashboardBinsWorker);
  });
}

function* fetchTotalPendingAlertsWorker({ filters }) {
  try {
    const { total } = yield call(fetchTotalPendingAlerts, { filters });

    yield put(fetchTotalPendingAlertsSuccess(total));
  } catch (error) {
    yield put(fetchTotalPendingAlertsFail());
  }
}

export function* watchFetchTotalPendingAlerts() {
  yield takeEvery(FETCH_TOTAL_PENDING_ALERTS, function* ({ payload: filters }) {
    yield fork(fetchTotalPendingAlertsWorker, { filters });
  });
}

function* fetchCaseAgingStatsWorker({ filters, caseAgingBins }) {
  try {
    const { total, ages, automationCases, manualCases, otherCases } =
      yield call(fetchCaseAgingStats, {
        filters,
        caseAgingBins
      });

    yield put(
      fetchCaseAgingStatsSuccess({
        total,
        ages,
        automationCases,
        manualCases,
        otherCases
      })
    );
  } catch (error) {
    yield put(fetchCaseAgingStatsFail());
  }
}

export function* watchFetchCaseAgingStats() {
  yield takeEvery(
    FETCH_CASE_AGING_STATS,
    function* ({ payload: { filters, caseAgingBins } }) {
      yield fork(fetchCaseAgingStatsWorker, { filters, caseAgingBins });
    }
  );
}
